import React from "react";
import { JobMatchingFeature } from "../index";
import styles from "./SliderWapper.module.css";
const SliderWrapper = ({ children }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <JobMatchingFeature />
      </div>
      <div className={styles.right}>{children}</div>
    </div>
  );
};

export { SliderWrapper };
